import type { Node } from "@xyflow/react";
import type { Frame } from "@/api/spaces";
import type { FrameData } from "@/lib/frame-data";

export function isTransientConversationFrameMetadata(
  metadata: Record<string, unknown> | undefined,
): boolean {
  return metadata?.transientConversationFrame === true;
}

export function isTransientConversationFrame(frame: Frame): boolean {
  return isTransientConversationFrameMetadata(frame.metadata);
}

export function isTransientConversationFrameNode(
  node: Node<FrameData>,
): boolean {
  return isTransientConversationFrameMetadata(node.data.metadata);
}

export function transientConversationFrameIds(
  frames: readonly FrameData[],
): Set<string> {
  return new Set(
    frames
      .filter((frame) => isTransientConversationFrameMetadata(frame.metadata))
      .map((frame) => frame.frameId),
  );
}
